export type * from "#template/nodes/object/fundamental"
export type * from "#template/nodes/object/mesh/fundamental"
export type * from "#template/nodes/object/curve/fundamental"
export type * from "#template/nodes/material/fundamental"
export type * from "#template/nodes/image/fundamental"
export type * from "#template/nodes/template-graph/fundamental"
export type * from "#template/nodes/transform/fundamental"
export type * from "#template/nodes/string/fundamental"
export type * from "#template/nodes/number/fundamental"
export type * from "#template/nodes/boolean/fundamental"
export type * from "#template/nodes/json/fundamental"

export type TextureResolution = "500px" | "1000px" | "2000px" | "original"
export type EnvironmentMapMode = "full" | "specularOnly"
export type {UiStyle} from "#template/interfaces/scene-object"
export type AccordionStyle = "autoClose" | "manualClose" | "stepInto" | "stepThrough"
export type DecalMaskType = "binary" | "opacity"
export type MaterialSide = "front" | "back" | "double"
export type LightType = "Corona" | "Blender"
export type UnitForDisplay = "mm" | "cm" | "m" | "in" | "ft"
export type BoundsEdgeNumber = 0 | 1 | 2 | 3

export type FilmicToneMapping = {mode: "filmic"}
export type FilmicAdvancedToneMapping = {mode: "filmic-advanced"; contrast: number; balance: number; colorBalance: number}
export type ContrastToneMapping = {mode: "contrast"; contrast: number; balance: number; colorBalance: number}
export type CoronaToneMapping = {mode: "corona"; highlightCompression: number; contrast: number; saturation: number}
export type PBRNeutralToneMapping = {mode: "pbr-neutral"}
export type LinearToneMapping = {mode: "linear"}
export type RGBCurveMapping = {
    mode: "rgbCurve"
    parameters: {
        fac: number
        [key: string]: [number, number] | number
    }
}
export type HueSaturationMapping = {
    mode: "hueSaturation"
    parameters: {
        fac: number
        hue: number
        saturation: number
        value: number
    }
}
export type ToneMapping =
    | FilmicToneMapping
    | ContrastToneMapping
    | CoronaToneMapping
    | PBRNeutralToneMapping
    | LinearToneMapping
    | FilmicAdvancedToneMapping
    | RGBCurveMapping
    | HueSaturationMapping

export enum MaterialSlotType {
    BaseColor = "baseColor",
    Metallic = "metallic",
    Specular = "specular",
    Roughness = "roughness",
    Anisotropic = "anisotropic",
    AnisotropicRotation = "anisotropicRotation",
    Alpha = "alpha",
    Normal = "normal",
    Sheen = "sheen",
    SheenTint = "sheenTint",
    Clearcoat = "clearcoat",
    ClearcoatRoughness = "clearcoatRoughness",
    Transmission = "transmission",
    Emission = "emission",
}

export type ColorValue = [number, number, number]
export type EulerValue = [number, number, number]
export type VectorValue = [number, number, number]
export type UvValue = [number, number]

export function isValidExternalId(id: string): id is ExternalId {
    if (id.length === 0) return false
    else return /^[a-zA-Z0-9_\/-]+$/.test(id)
}

export type ExternalId = string

export type PositionValue = [number, number, number]
